import { Screen } from '@modules/shared/services/window.service';

import { MediaSetting } from '../media-setting.interface';

export const Equal3SectionImageStyle: MediaSetting[] = [
  { screen: Screen.XXXS, key: '2_1_540', width: 540, height: 270, ratio: 2 },
  { screen: Screen.XS, key: '2_1_768', width: 768, height: 384, ratio: 2 },
  { screen: Screen.SM, key: '2_1_1024', width: 1024, height: 512, ratio: 2 },
  { screen: Screen.MD, key: '3_2_414', width: 500, height: 333, ratio: 1.5 },
  { screen: Screen.LG, key: '3_2_492', width: 500, height: 333, ratio: 1.5 },
  { screen: Screen.XL, key: '3_2_660', width: 600, height: 400, ratio: 1.5 },
];
